import React from 'react';
import stringHelper from '../../../../Helpers/stringHelper';
import TpSurveyService from '../../../../Services/tpSurveyService';
import ErrorMessage from '../../../ErrorMessage';
import SelectFieldCheckbox from './SelectFieldCheckbox';

// Dropdown of TpSurveys filtered by client and third-party system (TpInstance).
// Expects `multipleIdFilter` to carry { ClientId, TpInstanceId } (wire it with a
// field `idFilterArray` of [{filterName:'ClientId', valueName:'<clientField>'},
// {filterName:'TpInstanceId', valueName:'<instanceField>'}]).
export default class TpSurveyByClientAndInstanceSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    multipleIdFilter: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    const prev = prevProps.multipleIdFilter || {};
    const cur = this.props.multipleIdFilter || {};
    if (prev.ClientId !== cur.ClientId || prev.TpInstanceId !== cur.TpInstanceId) {
      this.populateListData();
    }
  }

  populateListData() {
    const filter = this.props.multipleIdFilter || {};
    const clientId = filter.ClientId;
    const tpInstanceId = filter.TpInstanceId;

    if (!clientId || !tpInstanceId) {
      this.setState({ selectValues: [] });
      return;
    }

    TpSurveyService.GetTpSurveysByClientAndInstance(clientId, tpInstanceId)
      .then((result) => {
        if (!Array.isArray(result)) {
          this.setState({ selectValues: [] });
          return;
        }
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result
          .sort((a, b) => (a.thirdPartySurveyName > b.thirdPartySurveyName ? 1 : -1))
          .forEach((survey) => {
            optValues.push({
              label: survey.thirdPartySurveyName + stringHelper.toBracket(survey.thirdPartySurveyId),
              value: survey.tpSurveyId,
              disabled: false,
            });
          });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('TPSBCI69');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
